import { render } from "./TataRuang.vue?vue&type=template&id=40e414de"
import script from "./TataRuang.vue?vue&type=script&lang=js"
export * from "./TataRuang.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__